import types from './types';

const defaultState = {
  chemicalProduct: null,
  initialData: {},
  isLoading: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  let initialData;
  switch (type) {
    case types.GET_CHEMICAL_PRODUCT_HISTORY:
      return { ...state, chemicalProduct: null, isLoading: true };
    case types.GET_CHEMICAL_PRODUCT_HISTORY_SUCCESS:
      return { ...state, chemicalProduct: data, isLoading: false };
    case types.GET_CHEMICAL_PRODUCT_HISTORY_FAILURE:
      return { ...state, isLoading: false };
    case types.GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA:
      return { ...state, initialData: {}, isLoading: true };
    case types.GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA_SUCCESS:
      return { ...state, initialData: data, isLoading: false };
    case types.GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA_FAILURE:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
